/* eslint-disable @typescript-eslint/no-unused-vars */
import { Info } from "assets/pois-bounty/svg";
import { usePoisBountyContext } from "components/PoisBountyWidgetV3/context";
import { useWebStoreContext } from "contexts";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useAppDispatch, useAppSelector } from "hooks";
import { onOpenPopUp, selectPoisBountyV3State } from "redux/slices";
import { getTimeLeft } from "utils/time";
import { Button, ClubDescriptionWidget, Container } from "./styles";

interface InfoButtonProps {}

export const InfoButton: React.FC<InfoButtonProps> = () => {
	const dispatch = useAppDispatch();
	const { nowTime } = useWebStoreContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { tracker, trackers } = useAppSelector(selectPoisBountyV3State);
	const { isPortrait, isPageVariant, isClub } = usePoisBountyContext();

	const onLearnMore = () => {
		const isUserEvent = trackers?.eventType === "user";
		dispatch(onOpenPopUp(isUserEvent ? "pb-pbftue-v2" : "pb-pbftue-v3"));
		const timeLeft = getTimeLeft(nowTime, tracker?.endTime, "seconds");
		const timeTotal =
			getTimeLeft(tracker?.startTime, tracker?.endTime, "seconds") || undefined;
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "learn_more_clicked",
			event_type: "pois_bounty_v3",
			action: "learn_more_clicked",
			source: "pois_bounty_v3",
			type: trackers?.eventType === "user" ? "personal" : "club",
			time_left: timeLeft,
			time_total: timeTotal,
			event_id: trackers?.eventId
		});
	};

	return (
		<Container>
			{!isPortrait && isPageVariant && isClub && (
				<ClubDescriptionWidget>
					<p>
						Club: <span>{trackers?.clubName}</span>
					</p>
				</ClubDescriptionWidget>
			)}
			<Button onClick={onLearnMore}>
				<Info />
			</Button>
		</Container>
	);
};
